import { Link, useParams } from 'react-router';
import ScreenHeader from '@legacy/components/layout/ScreenHeader';
import { Button } from '@legacy/components/mui-components';
import { Deck } from '@legacy/components/ui-components';
import { PageRoute } from '@legacy/routers/PageRoute';

export const Employee = () => {
  const { id } = useParams();

  return (
    <>
      <ScreenHeader />
      <PageRoute
        pageTitle={`Employee ${id}`}
        pageId="dc23305c-5d92-49ab-b67e-6e356218ff0b"
        pageIdentifier="DesignSevenEditEmployeeCompetence"
      >
        <Deck>
          <Deck.Item>
            <h2>Employee</h2>
            <Link to="competences">
              <Button component="span">Competences</Button>
            </Link>
          </Deck.Item>
        </Deck>
      </PageRoute>
    </>
  );
};
